import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { ResourceService } from '@smartsoftware/reflex-core';
import { SyncEntity } from '../models';

@Injectable()
export class SyncEntity_Service extends ResourceService<SyncEntity> {
    protected servicePath: string = '/SyncEntity';

    public ModelType = SyncEntity;

    constructor(
        protected http: HttpClient
    ) {
        super(http);
    }
}
